import {
  faBarcodeRead,
  faBarcodeScan,
  faBox,
  faBuilding,
  faCalendarClock,
  faCogs,
  faDiagramProject,
  faFiles,
  faGear,
  faHashtag,
  faMailboxFlagUp,
  faMailBulk,
  faMessages,
  faPenField,
  faTerminal,
  faTextSize,
  faUsers,
} from '@fortawesome/pro-regular-svg-icons';
import {Image} from '@mantine/core';
import logo from '../assets/mm_logo.png';
import {ROUTES} from '../routes';
import {PrimaryNavLinkProps} from './primary-nav-link';
import {SubNavMenuProps} from './sub-nav-menu';
import {Roles} from '../api/generated/enums';

export const AllRoles: Roles[] = [
  'Global Admin',
  'Partner Site Manager',
  'Partner Site User',
];

export const SnTrackingRoles: Roles[] = [
  'Global Admin',
  'Partner Site Manager',
  'Partner Site User',
  'Serial Number Tracking User' as Roles,
];

export const PrimaryNavLinkItems = {
  Dashboard: {
    to: ROUTES.DASHBOARD.path,
    children: (
      <Image
        src={logo}
        alt='MMValve ARF logo'
        h={34}
        w={'auto'}
        fit='contain'
      />
    ),
  },
  Users: {
    to: ROUTES.ADMIN.USERS.INDEX.path,
    icon: faUsers,
    title: 'Users',
    authProps: {role: 'Global Admin'},
  },
  PartnerSites: {
    to: ROUTES.ADMIN.PARTNER_SITES.INDEX.path,
    icon: faBuilding,
    title: 'Partner Sites',
    authProps: {role: 'Global Admin'},
  },
  SerialNumberTracking: {
    to: ROUTES.ADMIN.SERIAL_NUMBER_TRACKING.INDEX.path,
    icon: faHashtag,
    title: 'S/N Tracking',
    authProps: {role: SnTrackingRoles},
  },
  Jobs: {
    to: ROUTES.ADMIN.JOBS.INDEX.path,
    icon: faBox,
    title: 'Jobs',
    authProps: {
      role: AllRoles,
    },
  },
  RepairDocuments: {
    to: ROUTES.ADMIN.REPAIR_DOCUMENTS.INDEX.path,
    icon: faFiles,
    title: 'Repair Documentation',
    authProps: {
      role: AllRoles,
    },
  },
  Reviews: {
    to: ROUTES.ADMIN.REVIEWS.INBOX.path,
    icon: faMessages,
    title: 'Review Inbox',
    authProps: {
      role: 'Global Admin',
      permission: 'Review Inbox: Manage',
    },
  },
  Fields: {
    to: ROUTES.ADMIN.FIELDS.INDEX.path,
    icon: faPenField,
    title: 'Fields',
    authProps: {role: 'Global Admin'},
  },
  Codes: {
    to: ROUTES.ADMIN.CODES.INDEX.path,
    icon: faBarcodeScan,
    title: 'Codes',
    authProps: {role: 'Global Admin'},
  },
  ActionCodes: {
    to: ROUTES.ADMIN.ACTION_CODES.INDEX.path,
    icon: faBarcodeRead,
    title: 'Action Codes',
    authProps: {role: 'Global Admin'},
  },
  CosSelectionOptions: {
    to: ROUTES.ADMIN.COS_SELECTION_OPTIONS.INDEX.path,
    icon: faCalendarClock,
    title: 'COS Options',
    authProps: {role: 'Global Admin'},
  },
  ActionClasses: {
    to: ROUTES.ADMIN.ACTION_CLASSES.INDEX.path,
    icon: faDiagramProject,
    title: 'Action Classes',
    authProps: {role: 'Global Admin'},
  },
  EmailEvaluations: {
    to: ROUTES.ADMIN.EMAIL_EVALUATIONS.INDEX.path,
    icon: faMailBulk,
    title: 'Email Evaluations',
    authProps: {
      role: AllRoles,
    },
  },
  EmailLog: {
    to: ROUTES.ADMIN.EMAIL_LOG.INDEX.path,
    icon: faMailboxFlagUp,
    title: 'Email Log',
    authProps: {
      role: AllRoles,
    },
  },
  Settings: {
    to: ROUTES.ADMIN.SETTINGS.INDEX.path,
    icon: faCogs,
    title: 'Settings',
    authProps: {role: 'Global Admin'},
  },
  Logs: {
    to: ROUTES.ADMIN.LOGS.INDEX.path,
    icon: faTerminal,
    title: 'Logs',
    authProps: {role: 'Global Admin'},
  },
  Routes: {
    to: ROUTES.ADMIN.ROUTE_PATTERNS.INDEX.path,
    icon: faTextSize,
    title: 'Routes',
    authProps: {role: 'Global Admin'},
  },
} as const satisfies Record<string, PrimaryNavLinkProps>;

export const SubNavItems = {
  ConfigurationSubNavItem: {
    icon: faGear,
    title: 'Configuration',
    authProps: {
      role: AllRoles,
    },
    data: [
      PrimaryNavLinkItems.ActionClasses,
      PrimaryNavLinkItems.ActionCodes,
      PrimaryNavLinkItems.Codes,
      PrimaryNavLinkItems.CosSelectionOptions,
      PrimaryNavLinkItems.Fields,
      PrimaryNavLinkItems.EmailEvaluations,
    ],
  },
} as const satisfies Record<string, SubNavMenuProps>;
